export const FORM_FIELDS = {
  OWNERS_MATTERS: "owners-matters",
  NEW_SHIPPING_AGENCY: "new-shipping-agency",
  TRANSFER_DATE_AND_TIME: "transfer-date-and-time",
  ADDITIONAL_DOCUMENTS: "additional-documents",
} as const;
